var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_3",
    transform: "scale(0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_3",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAACW0lEQVRIie2WQW9MURTH/3emujCp7kwTxYiKiFjQLoqu2SMSHZ2N72Aj1oJPoI1NLXwBFlMrsdCRWJBWJUZZiBkWhITMJNqfxT30zeu778102PWfTPLufeec33lnzjv3SdvqQkAJWLFf6X9BJoAZoGDrPLDAhhaAvN0rmO14v9ARoG2ABnAXqLFZNbvXsHULKPYDPpUA6VYn02LnMthjW846w3cgvgGMSBqVdFTSzT7At4GcpGVJH5xzzaClNVI7vYJbUptYw8Wf+IikwUBeDyTV5EtYjvk+lfRD0l5JhxN8By3289ATF9jozKhuxOwuRu7VAAfsBF4Fnvgj9joGBcwlOI4CA8B74JDZfQLWgUlbz6aUejYLmgeeJTgOA0PAGnDabN8A9+z6QgoUfFXyIWiJzokU1XmzmQRywBjwDdgD7AO+ZICx2JvHK/A6xekzMA0cAM4CS8A1fIWedAH9o+Uk8EoPARaBHcBVS+KMJXUJ/9/3BC4B1S6g34GDQBH4ii97HpiyOOcCflVgf1pzJR0CUVXM9g6watdT+MYbwjdiXIv4KfZXHQvn3Jqkl4lZed13zs0DxyRdkbTL9huS6pJ+RvaieuGcWw9GJTxAAN4Bw2b3KLI/HYtxK8E3fYDgD/GQ6gZ8HNv/BcwD14GHKf7lNPA4/hD/12oBx4Nggxfxp1QFaPYBa+ArOAHsToUmJFHpAzyTFjvrC6TeU6Y9+GaBVyW17bopaVb+TI6rJmnObCSpJelt9zkmCDgBlOn8vI1OuCo2HPCv42WyGqmPZEr4Q3+J0BjcVky/Af1fu+TujBNoAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscount);
export default __webpack_public_path__ + "static/media/icon__discount.b94e6be8c8ebc0a6321a4b0c3b8e6355.svg";
export { ForwardRef as ReactComponent };